var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-no-data"},[_c('img',{attrs:{"src":require("@/assets/img/nodata.png")}}),_c('h4',[_vm._v("No Data")]),_c('p',[_vm._v("There is nothing to show here.")])])
}]

export { render, staticRenderFns }